import React from "react";
import PropTypes from "prop-types";
import { Frame } from "@bitesite/react-figstrap";
import SquareCardFields from "../../square_cards/square_card_fields";
import styled from "styled-components/macro";

/* Avoiding odc-ui Text component because this is used in the context of paige-styling */
const DisclaimerText = styled.div`
  font-size: 14px;
`;

const SquareCardForm = ({ onSquareCardFieldsChange }) => {
  return (
    <Frame vertical gap={10}>
      <div>Please enter your credit card information</div>
      <SquareCardFields onChange={onSquareCardFieldsChange} />
      <DisclaimerText>
        Please note that by adding your credit card information, you authorize
        Ottawa Derm &amp; Surgery Centre Inc. to charge your credit card. You also understand
        that your information will be securely saved to file for future
        transactions on your account. Your information will be processed by our
        payment processor, Square, Inc.
      </DisclaimerText>
    </Frame>
  );
};

SquareCardForm.propTypes = {
  onSquareCardFieldsChange: PropTypes.func.isRequired,
};

export default SquareCardForm;
